/**
 * RoseAnimation — falling petals + gentle sway on the rose emoji.
 * Pure SVG + CSS keyframes so we don't pull a Lottie runtime.
 * 1.4s duration matches LiveGiftOverlay's burst window.
 */
export default function RoseAnimation({ size = 140 }) {
  return (
    <div
      className="pointer-events-none"
      style={{ width: size, height: size, position: "relative" }}
    >
      <style>{`
        @keyframes rose-sway {
          0%   { transform: rotate(-8deg) scale(0.6); opacity: 0; }
          25%  { transform: rotate(4deg) scale(1.4); opacity: 1; }
          60%  { transform: rotate(-3deg) scale(1.2); opacity: 1; }
          100% { transform: rotate(0deg) scale(1); opacity: 0; }
        }
        @keyframes rose-petal-fall {
          0%   { transform: translate(0, -30%) rotate(0deg); opacity: 0; }
          20%  { opacity: 1; }
          100% { transform: translate(var(--dx, 20px), 110%) rotate(var(--rot, 360deg)); opacity: 0; }
        }
      `}</style>
      <div
        style={{
          position: "absolute",
          inset: 0,
          fontSize: size * 0.72,
          lineHeight: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          animation: "rose-sway 1.4s cubic-bezier(.22,1,.36,1) forwards",
          filter: "drop-shadow(0 0 24px rgba(244,63,94,0.7))",
        }}
      >
        🌹
      </div>
      {/* Falling petals */}
      {[
        { dx: "-42px", rot: "480deg", delay: "0.05s", left: "38%" },
        { dx: "24px",  rot: "-320deg", delay: "0.15s", left: "62%" },
        { dx: "-18px", rot: "260deg", delay: "0.28s", left: "50%" },
        { dx: "36px",  rot: "-420deg", delay: "0.4s",  left: "44%" },
        { dx: "-30px", rot: "380deg", delay: "0.55s", left: "58%" },
      ].map((p, i) => (
        <div
          key={i}
          style={{
            position: "absolute",
            left: p.left,
            top: "18%",
            width: 10,
            height: 12,
            background: "linear-gradient(135deg, #f43f5e, #e11d48)",
            borderRadius: "50% 0 50% 50%",
            transform: "translateX(-50%)",
            animation: `rose-petal-fall 1.4s ease-in ${p.delay} forwards`,
            "--dx": p.dx,
            "--rot": p.rot,
          }}
        />
      ))}
    </div>
  );
}
